import { FAIRE_DIRECT_LANDING_PAGE_REDESIGN_BRAND_SUMMARY_240827 } from "@faire/web-api/indigofair/settings/FAIRE_DIRECT_LANDING_PAGE_REDESIGN_BRAND_SUMMARY_240827";

import { useSetting, useAssignSetting } from "./__internal__/useSetting";

export const useSettingFaireDirectLandingPageRedesignBrandSummary =
  (): boolean =>
    useSetting(FAIRE_DIRECT_LANDING_PAGE_REDESIGN_BRAND_SUMMARY_240827, false);

export const useAssignFaireDirectLandingPageRedesignBrandSummary = () =>
  useAssignSetting(FAIRE_DIRECT_LANDING_PAGE_REDESIGN_BRAND_SUMMARY_240827);
